import { render } from "./Xfujun2024.vue?vue&type=template&id=73e34546&scoped=true"
import script from "./Xfujun2024.vue?vue&type=script&lang=js"
export * from "./Xfujun2024.vue?vue&type=script&lang=js"

import "./Xfujun2024.vue?vue&type=style&index=0&id=73e34546&scoped=true&lang=css"

import exportComponent from "C:\\ZYSRC\\FW\\fwm_web-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e34546"]])

export default __exports__